import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Grid, TextField, Typography, MenuItem, FormControlLabel, Switch } from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { injectIntl } from "react-intl";
const useStyles = makeStyles(theme => ({
    card: {
        backgroundColor: "#fff",
        borderRadius: 8,
        paddingTop: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
        [theme.breakpoints.down("sm")]: {
            paddingTop: 8,
            paddingLeft: 0,
            paddingRight: 0
        }
    },
    header: {
        paddingLeft: 12,
        paddingRight: 12,
        paddingBottom: 6,
        marginBottom: 24,
        alignItems: "center",
        display: "flex"
    }
}));
addRegisteredSectionLayout({
    name: "SkatteEtaten_Lån_Section",
    displayName: "SkatteEtaten_Lån_Section",
    settings: {}
});
var LoanTypeEnum;
(function (LoanTypeEnum) {
    LoanTypeEnum["regular"] = "Vanlig";
    LoanTypeEnum["greenMortgage"] = "Gr\u00F8nt husl\u00E5n";
    LoanTypeEnum["reim"] = "Ramme l\u00E5n";
    LoanTypeEnum["annuity"] = "Annuitetsl\u00E5n";
    LoanTypeEnum["series"] = "Seriel\u00E5n";
})(LoanTypeEnum || (LoanTypeEnum = {}));
const SkatteEtaten_Lån_Section = injectIntl((props) => {
    const { className } = props;
    const classes = useStyles();
    const loans = [
        {
            cash: "1000000",
            bank: "Sparebanken Vest",
            type: LoanTypeEnum.regular,
            account: "1234 0506",
            canRefin: true,
            shouldRefin: true
        },
        {
            cash: "500000",
            bank: "Lånekassen",
            type: LoanTypeEnum.annuity,
            account: "2222 5555",
            canRefin: false
        },
        {
            cash: "300000",
            bank: "Standard Consumer Bank",
            type: LoanTypeEnum.series,
            account: "4695 0920",
            canRefin: true,
            shouldRefin: true
        }
    ];
    return (_jsx(Grid, Object.assign({ container: true, spacing: 3, className: clsx(className, classes.card), direction: "column" }, { children: loans.map((l, i) => (_jsx(LoanItem, { loan: l, idx: i }, l.account))) }), void 0));
});
const LoanItem = (props) => {
    const { loan, idx } = props;
    const [cashVal, setCashVal] = useState(loan.cash);
    const [typeVal, setTypeVal] = useState(loan.type.toString());
    const [refiVal, setRefiVal] = useState(loan.shouldRefin);
    return (_jsxs(Grid, Object.assign({ item: true, container: true, direction: "row" }, { children: [_jsx(Grid, Object.assign({ item: true, container: true, style: {
                    borderRadius: "50%",
                    backgroundColor: "#ABDCBC",
                    width: 48,
                    height: 48,
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 20,
                    marginRight: 36
                } }, { children: _jsx(Typography, { children: idx + 1 }, void 0) }), void 0), _jsx(Grid, Object.assign({ item: true }, { children: _jsxs(Grid, Object.assign({ container: true, direction: "column" }, { children: [_jsx(Grid, Object.assign({ item: true }, { children: _jsxs(Typography, Object.assign({ variant: "caption" }, { children: [loan.bank, " Konto **", loan.account.substring(loan.account.length - 4, loan.account.length)] }), void 0) }), void 0), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(TextField, { placeholder: "Innskudd", variant: "outlined", value: cashVal, onChange: e => setCashVal(e.target.value) }, void 0) }), void 0), _jsx(Grid, Object.assign({ item: true }, { children: _jsx(Typography, Object.assign({ variant: "caption" }, { children: "Type l\u00E5n" }), void 0) }), void 0), _jsx(Grid, Object.assign({ item: true, xs: 4 }, { children: _jsx(TextField, Object.assign({ select: true, variant: "outlined", value: typeVal, onChange: e => setTypeVal(e.target.value), style: { width: 223 } }, { children: Object.values(LoanTypeEnum).map(x => (_jsx(MenuItem, Object.assign({ value: x }, { children: x }), x))) }), void 0) }), void 0), loan.canRefin && (_jsx(Grid, Object.assign({ item: true }, { children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: !!refiVal, onChange: e => setRefiVal(e.target.checked) }, void 0), label: "Dette l\u00E5net skal innfris ved refinansiering" }, void 0) }), void 0))] }), void 0) }), void 0)] }), void 0));
};
SkatteEtaten_Lån_Section.displayName = "DploySkatteEtaten_Lån_Section";
export { SkatteEtaten_Lån_Section };
//# sourceMappingURL=SkatteEtaten_L%C3%A5n_Section.js.map